import { render, staticRenderFns } from "./ShowDomesticFlight.vue?vue&type=template&id=08adfcff"
import script from "./ShowDomesticFlight.vue?vue&type=script&lang=js"
export * from "./ShowDomesticFlight.vue?vue&type=script&lang=js"
import style0 from "./ShowDomesticFlight.vue?vue&type=style&index=0&id=08adfcff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports